export default __webpack_public_path__ + "static/media/grafema_nutrana_05.98b3257c.jpg";